<script lang="ts">
  import clsx from 'clsx';
  import type { FieldLabelProps } from './types';

  const { inputId, label, visuallyHidden, class: className }: FieldLabelProps = $props();
</script>

<label
  for={inputId}
  class={clsx(
    {
      ['sr-only']: visuallyHidden,
      ['block text-sm']: !visuallyHidden,
    },
    className,
  )}
>
  {label}
</label>
